import { Theme } from '@mui/material';
/**
 * Styling for CcfEmptyCopilotState
 * @returns CcfEmptyCopilotState CSS properties as a JSON object
 *  @example -
 * ```
 * styles = ccfEmptyCopilotStateStyles(theme);
 * ```
*/
const ccfEmptyCopilotStateStyles = (theme: Theme) => {
  const styles = {
    emptyStateContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      height: '100%',
      margin: '0 0.625rem',
    },
    sparklesIcon: {
      height: '4.5rem', 
      width: '4.5rem', 
      alignSelf: 'center', 
      m: 2, 
    },
    suggestionIcon: { 
      alignSelf: 'flex-start', 
    },
    contentContainer: { 
      display: 'flex', 
      flexDirection: 'row',
      alignItems: 'center', 
      gap: 1, 
    },
    textContainer: {
      display: 'flex', 
      flexDirection: 'column',
    },
    title: { 
      fontWeight: 'bold', 
    },
    description: {
      color:theme?.palette?.background?.darkGrey,
    },
  }
  return styles
}

export default ccfEmptyCopilotStateStyles